<template>
  <div class="what-we-search-wrap">
    <div class="what-we-search-valors">
      <div class="inner">
        <div class="main-heading">
          <h2 class="whatWeSearch-text-h2">
            What&nbsp;<span class="colored-text">We Search</span>
          </h2>
        </div>
        <div class="text-wrap">
          <div class="col">
            <div class="image">
              <img
                decoding="async"
                class="ls-is-cached lazyloaded"
                :src="this.publicPath+'assets/images/persistenceChart.png'"
              />
            </div>
            <div class="heading">
              <p>Persistence</p>
            </div>
            <div class="text">
              <p>
                We remain resolute and unwavering in our pursuit of excellence,
                striving to be the finest in our endeavors.
              </p>
            </div>
          </div>
          <div class="col">
            <div class="image">
              <img
                decoding="async"
                class="ls-is-cached lazyloaded"
                :src="this.publicPath+'assets/images/respectIcon.png'"
              />
            </div>
            <div class="heading">
              <p>Respect</p>
            </div>
            <div class="text">
              <p>
                We hold our clients, their players, and our team members in high
                regard, emphasizing professionalism, integrity, and fairness as
                unwavering principles without any concessions.
              </p>
            </div>
          </div>
          <div class="col">
            <div class="image">
              <img
                decoding="async"
                class="ls-is-cached lazyloaded"
                :src="this.publicPath+'assets/images/qualityIcon.png'"
              />
            </div>
            <div class="heading">
              <p>Ownership</p>
            </div>
            <div class="text">
              <p>
                We take responsibility for our tasks and maintain a consistent
                track record of dependable performance, always upholding the
                utmost standards of quality.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "What_weSearch",
  components: {},

  data() {
    return {
      publicPath:process.env.VUE_APP_PUBLIC_PATH ?? "/",
      lang: localStorage.getItem("language") ?? "en",
      loadingComplete: false,
    };
  },
  computed: {},
  mounted() {},
  created() {
    document.body.style.fontFamily = "Poppins, sans-serif";
  },
  methods: {},
};
</script>

<style scoped>
@media only screen and (min-width: 1024px) {
  .what-we-search-valors {
    /* margin-top: -65px; */
    margin-top: 0px;
  }
}
@media only screen and (max-width: 991px) {
  .what-we-search-wrap {
    position: relative;
  }
}

@media only screen and (min-width: 992px) {
  .what-we-search-wrap {
    position: relative;
  }
}

@media (max-width: 700px) {
  .what-we-search-valors .inner .text-wrap .col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: initial;
    position: relative;
    box-sizing: border-box;
    min-height: 0!important;
    /* min-height: 275px !important; */
    min-width: 100% !important;
    background-color: #07020a;
    border: 3px solid cornflowerblue;
    border-radius: 20px;
    box-shadow: 0 0 10px 5px cornflowerblue;
    margin: 20px 15px;
    padding: 25px;
    text-align: center;
    transition: box-shadow 0.5s, color 0.5s;
    width: 100%;
    padding-top: 20px !important;
  }
}

@media (max-width: 569px) {
  .what-we-search-valors .inner .text-wrap .col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: initial;
    position: relative;
    box-sizing: border-box;
    min-height: 0!important;
    /* min-height: 275px !important; */
    min-width: 250px !important;
    background-color: #07020a;
    border: 3px solid cornflowerblue;
    border-radius: 20px;
    box-shadow: 0 0 10px 5px cornflowerblue;
    margin: 20px 15px;
    padding: 25px;
    text-align: center;
    transition: box-shadow 0.5s, color 0.5s;
    width: 100%;
    padding-top: 20px !important;
  }
}

.whatWeSearch-text-h2 {
  font-weight: 600;
  font-size: 32px;
  line-height: 1.4rem;
  letter-spacing: 2px;
  margin: 20px 0px;
}
.what-we-search-valors {
  display: block;
  background-color: #09041f;
  box-shadow: 0 0 35px 0 rgba(0, 0, 0, 0.1);
}

.what-we-search-valors .inner {
  max-width: 1200px;
  margin: auto;
  color: #ffffff;
  padding-top: 65px;
  padding-bottom: 65px;
}

.what-we-search-valors .inner .text p {
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1.6rem;
  margin: 0;
}

.main-heading {
  margin-left: 15px;
}

.colored-text {
  display: contents;
  color: #e77842 !important;
}

.what-we-search-valors .inner .text-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.what-we-search-valors .inner .text-wrap .col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: initial;
  position: relative;
  box-sizing: border-box;
  min-height: 400px;
  min-width: 330px;
  background-color: #07020a;
  border: 3px solid cornflowerblue;
  border-radius: 20px;
  box-shadow: 0 0 10px 5px cornflowerblue;
  margin: 20px 15px;
  padding: 25px;
  text-align: center;
  transition: box-shadow 0.5s, color 0.5s;
  width: 100%;
  padding-top: 50px;
}
.what-we-search-valors .inner .text-wrap .col:hover {
  border: 3px solid rgb(123, 166, 246);
  box-shadow: 0 0 20px 5px rgb(123, 166, 246);
  text-align: center;
  transition: box-shadow 0.5s, color 0.5s;
}

.what-we-search-valors .inner .text-wrap .col .letter {
  position: absolute;
  left: 25px;
  top: 25px;
  opacity: 0.05;
  color: #ffffff;
  font-family: "Montserrat", sans-serif;
  font-size: 120px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 101px;
}

.what-we-search-valors .inner .text-wrap .col .heading > * {
  color: #cfcfcf;
  font-family: "Montserrat", sans-serif;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 34px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin: 0;
}

.what-we-search-valors .inner .text-wrap .col .image {
  height: 79px;
  width: auto;
}

.what-we-search-valors .inner .text-wrap .col .image img {
  /* width: 100%;
  height: 100%; */
  width: 150px;
  height: 85px;
  object-fit: contain;
}
</style>
